// extracted by mini-css-extract-plugin
export var active = "_2i-7";
export var backButton = "_2i-6";
export var clone = "_2i-c";
export var collapseBar = "_2i-g";
export var collapseMode = "_2i-i";
export var dragHandle = "_2i-a";
export var dropdownIcon = "_2i-e";
export var hidden = "_2i-o";
export var iconContainer = "_2i-l";
export var iconSwapper = "_2i-n";
export var navItem = "_2i-4";
export var navItemIcon = "_2i-d";
export var navProfile = "_2i-5";
export var notificationDot = "_2i-m";
export var optionsContainer = "_2i-f";
export var primaryNav = "_2i-0";
export var primaryTab = "_2i-j";
export var secondaryNav = "_2i-1";
export var selected = "_2i-k";
export var settingsNav = "_2i-2";
export var settingsNavItems = "_2i-3";
export var show = "_2i-b";
export var sideNav = "_2i-h";
export var teamItem = "_2i-8";
export var userProfileItem = "_2i-9";